import './index.css'
import './i18n.ts'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'

import App from './App.tsx'
import { NotificationContainer } from './components/index.ts'
import { PageLoading } from './components/PageLoading.tsx'
import { applyThemeMode, AppThemeProvider, getInitialThemeMode } from './contexts/ThemeContext.tsx'

const queryClient = new QueryClient()

applyThemeMode(getInitialThemeMode())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <AppThemeProvider>
    <Suspense fallback={<PageLoading />}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
      <NotificationContainer />
    </Suspense>
  </AppThemeProvider>,
)
